import { render } from "./RrspForm.vue?vue&type=template&id=c8dd0b40&scoped=true"
import script from "./RrspForm.vue?vue&type=script&lang=js"
export * from "./RrspForm.vue?vue&type=script&lang=js"

import "./RrspForm.vue?vue&type=style&index=0&id=c8dd0b40&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8dd0b40"]])

export default __exports__